document.querySelectorAll('.header__primary-nav-item').forEach(navItem => {
  const tabs = navItem.querySelectorAll('.header-tab');
  const blocks = navItem.querySelectorAll('.content-box-menu > div');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      blocks.forEach(block => block.classList.remove('active'));
      const tabClass = Array.from(tab.classList).find(c => c.startsWith('header-tab__title-'));
      if (tabClass) {
        const number = tabClass.split('-').pop();
        const blockToActivate = navItem.querySelector(`.block-tab-${number}`);
        if (blockToActivate) {
          blockToActivate.classList.add('active');
        }
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
    const links = document.querySelectorAll('ul.submenu a');
    const linksNew = document.querySelectorAll('ul.submenu a');
    const linksMobile = document.querySelectorAll('.mobile-mega-menu__sublist a');
    const linksNewMobile = document.querySelectorAll('.mobile-mega-menu__sublist a');

    links.forEach(function(link) {
        if (link.href.includes("Ver-todo")) {
            link.classList.add('view-all-link');
        }
    });

    linksNew.forEach(function(linksNew) {
        if (linksNew.href.includes("Nuevo")) {
            linksNew.classList.add('new-link');
        }
    });

    linksMobile.forEach(function(link) {
        if (link.href.includes("Ver-todo")) {
            link.classList.add('view-all-link');
        }
    });

    linksNewMobile.forEach(function(linksNew) {
        if (linksNew.href.includes("Nuevo")) {
            linksNew.classList.add('new-link');
        }
    });
});

document.addEventListener("DOMContentLoaded", function() {
  const mainTriggers = document.querySelectorAll(".mega-menu__trigger");
  const mainBlocks = document.querySelectorAll(".header-tabs-mobile");
  const imageBlocks = document.querySelectorAll(".block-images-container");

  mainTriggers.forEach(trigger => {
    trigger.addEventListener("click", function() {
      const index = this.getAttribute("data-index");
      
      mainTriggers.forEach(t => t.classList.remove("active"));
      this.classList.add("active");

      mainBlocks.forEach(block => {
        block.style.display = (block.getAttribute("data-index") === index) ? "block" : "none";
      });

      imageBlocks.forEach(imgBlock => {
        imgBlock.style.display = (imgBlock.getAttribute("data-index") === index) ? "block" : "none";
      });
    });
  });

  const tabTitles = document.querySelectorAll(".header-tab");
  tabTitles.forEach(tab => {
    tab.addEventListener("click", function() {
      const tabId = this.getAttribute("data-tab-id");
      const parentBlock = this.closest(".header-tabs-mobile");
      parentBlock.querySelectorAll(".header-tab").forEach(t => t.classList.remove("active"));
      this.classList.add("active");
      parentBlock.querySelectorAll(".tab-panel-menu").forEach(panel => {
        panel.style.display = (panel.getAttribute("data-tab-content") === tabId) ? "block" : "none";
      });
    });
  });

  document.body.addEventListener("click", function(e) {
    const header = e.target.closest(".menu-item-header.has-submenu");
    if (!header) return;
    
    e.preventDefault();
    
    const parent = header.closest(".mobile-mega-menu__item");
    const sublist = parent.querySelector(".mobile-mega-menu__sublist");
    const container = header.closest(".mobile-mega-menu__list");
    
    const isOpen = header.classList.contains("is-open");

    container.querySelectorAll(".menu-item-header.is-open").forEach(openHeader => {
      openHeader.classList.remove("is-open");
      const openSublist = openHeader.closest(".mobile-mega-menu__item").querySelector(".mobile-mega-menu__sublist");
      if (openSublist) {
        openSublist.style.display = "none";
      }
    });

    if (!isOpen) {
      header.classList.add("is-open");
      sublist.style.display = "block";
    }
  });
});


document.addEventListener('DOMContentLoaded', function() {
  const swiper = new Swiper('.collection-swiper', {
    slidesPerView: "auto",
    spaceBetween: 16,

    navigation: {
      nextEl: '.button-next',
      prevEl: '.button-prev',
    },
  });
});

document.addEventListener('DOMContentLoaded', () => {
  
  const filterByJson = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const currentVariantId = urlParams.get('variant');
    const galleryItems = document.querySelectorAll('.product-gallery__media');

    if (!currentVariantId) {
      const colorInputs = document.querySelectorAll('.variant-picker__option-values input[type="radio"]');
      colorInputs.forEach(input => {
        input.checked = false;
        input.removeAttribute('checked');
      });

      galleryItems.forEach(item => {
        item.style.setProperty('display', 'block', 'important');
        item.removeAttribute('hidden');
      });

      window.dispatchEvent(new Event('resize'));
    }

    const jsonScript = document.querySelector('script[type="application/ld+json"]');
    if (!jsonScript) return;

    try {
      const data = JSON.parse(jsonScript.textContent);
      const variantData = data.hasVariant.find(v => v['@id'].includes(currentVariantId));
      
      if (!variantData || !variantData.image) return;

      const featuredImageFullUrl = variantData.image.split('?')[0];
      const baseName = featuredImageFullUrl.split('/').pop().split('.')[0]; 
      const colorKey = baseName.includes('tomate') ? 'tomate' : 
                       baseName.includes('oceano') ? 'oceano' : 
                       '26-01910-073'; 

      galleryItems.forEach(item => {
        const img = item.querySelector('img');
        if (!img) return;

        const imgSrc = (img.getAttribute('src') || img.getAttribute('srcset')).toLowerCase();
        
        if (imgSrc.includes(colorKey)) {
          item.style.setProperty('display', 'block', 'important');
          item.removeAttribute('hidden');
        } else {
          item.style.setProperty('display', 'none', 'important');
          item.setAttribute('hidden', 'true');
        }
      });

      window.dispatchEvent(new Event('resize'));
      const carousel = document.querySelector('scroll-carousel');
      if (carousel) carousel.scrollTo({ left: 0 });

    } catch (e) {
      console.error("Error filtrando imágenes:", e);
    }
  };

  document.addEventListener('change', (e) => {
    if (e.target.closest('.variant-picker__option-values')) {
       filterByJson();
    }
  });

  const observer = new MutationObserver((mutations) => {
    filterByJson();
  });

  const productInfo = document.querySelector('.product');
  if (productInfo) observer.observe(productInfo, { childList: true, subtree: true });

  filterByJson(); 
});

(function() {
  function updateAllCartDots() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartDots = document.querySelectorAll('cart-dot, .header__cart-dot');
        cartDots.forEach(dot => {
          dot.textContent = cart.item_count;
          
          if (cart.item_count > 0) {
            dot.classList.remove('is-hidden');
            dot.classList.add('is-visible');
            dot.removeAttribute('hidden');
            dot.style.display = 'flex';
          } else {
            dot.classList.add('is-hidden');
            dot.classList.remove('is-visible');
            dot.setAttribute('hidden', '');
            dot.style.display = 'none';
          }
        });
      })
    .catch(error => console.error('Error actualizando carrito:', error));
  }

  const originalFetch = window.fetch;
  window.fetch = function() {
    return originalFetch.apply(this, arguments).then(response => {
      if (response.url.includes('/cart/add') || 
          response.url.includes('/cart/change') || 
          response.url.includes('/cart/update') || 
          response.url.includes('/cart/clear')) {
        
        setTimeout(updateAllCartDots, 500);
      }
      return response;
    });
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('form[action="/cart/add"]') || e.target.closest('.product-form__submit')) {
      setTimeout(updateAllCartDots, 1000);
    }
  });
})();

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-target]');
  if (btn) {
    const targetId = btn.getAttribute('data-target');
    const drawer = document.getElementById(targetId);
    if (drawer) {
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('no-scroll');
    }
  }

  if (e.target.closest('[data-action="close-drawer"]') || e.target.classList.contains('custom-drawer-overlay')) {
    const openDrawer = document.querySelector('.custom-drawer[aria-hidden="false"]');
    if (openDrawer) {
      openDrawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('no-scroll');
    }
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    const openDrawer = document.querySelector('.custom-drawer[aria-hidden="false"]');
    if (openDrawer) {
      openDrawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('no-scroll');
    }
  }
});



document.addEventListener("DOMContentLoaded", function(){
	const menus = document.querySelectorAll(".footer-menu");

	menus.forEach(menu => {
		const button = menu.querySelector(".footer-menu__title");
		const content = menu.querySelector(".footer-menu__links");

		button.addEventListener("click", function(){
			if(window.innerWidth >= 600) return;
			if(menu.classList.contains("active")){
				content.style.height = content.scrollHeight + "px";
				requestAnimationFrame(() => {
					content.style.height = "0px";
				});
				menu.classList.remove("active");
			}else{
				menu.classList.add("active");
				content.style.height = content.scrollHeight + "px";
				content.addEventListener("transitionend", function(){
					if(menu.classList.contains("active")){
						content.style.height = "auto";
					}
				},{once:true});
			}
		});
	});
});

// Size dropdown add-to-cart on product cards (PLP)
(function () {
  var activeBackdrop = null;

  function isMobile() {
    return window.innerWidth < 960;
  }

  function findVariantForSize(variants, sizeOptionPos, colorOptionPos, sizeValue, colorValue) {
    var sizeKey = 'option' + sizeOptionPos;
    var colorKey = 'option' + colorOptionPos;
    var matchFn = function (requireAvailable) {
      return variants.find(function (v) {
        return v[sizeKey] === sizeValue &&
          (colorOptionPos === 0 || v[colorKey] === colorValue) &&
          (!requireAvailable || v.available);
      });
    };
    return matchFn(true) || matchFn(false);
  }

  function getColorValueForCard(card, dropdown) {
    var colorOptionPos = parseInt(dropdown.dataset.colorOptionPosition, 10);
    if (colorOptionPos === 0) return null;
    var variantId = card.dataset.currentVariantId || dropdown.dataset.initialVariant;
    if (!variantId) return null;
    var variants = JSON.parse(dropdown.dataset.variants);
    var v = variants.find(function (v) { return String(v.id) === String(variantId); });
    return v ? v['option' + colorOptionPos] : null;
  }

  function createBackdrop(onClose) {
    if (activeBackdrop) return;
    var backdrop = document.createElement('div');
    backdrop.className = 'product-card__size-backdrop';
    document.body.appendChild(backdrop);
    document.body.style.overflow = 'hidden';
    backdrop.addEventListener('click', onClose);
    activeBackdrop = backdrop;
  }

  function removeBackdrop() {
    if (activeBackdrop) {
      activeBackdrop.remove();
      activeBackdrop = null;
      document.body.style.overflow = '';
    }
  }

  function updateStockLabels(dropdown, card) {
    var variants = JSON.parse(dropdown.dataset.variants);
    var stocks = JSON.parse(dropdown.dataset.stocks || '{}');
    var sizeOptionPos = parseInt(dropdown.dataset.sizeOptionPosition, 10);
    var colorOptionPos = parseInt(dropdown.dataset.colorOptionPosition, 10);
    var colorValue = getColorValueForCard(card, dropdown);

    dropdown.querySelectorAll('.product-card__size-btn').forEach(function (btn) {
      var stockEl = btn.querySelector('.size-stock');
      if (!stockEl) return;
      var v = variants.find(function (v) {
        return v['option' + sizeOptionPos] === btn.dataset.sizeValue &&
          (colorOptionPos === 0 || v['option' + colorOptionPos] === colorValue);
      });
      var qty = v ? (stocks[String(v.id)] || 0) : 0;
      var threshold = parseInt(dropdown.dataset.lowStockThreshold || '10', 10);
      if (qty > 0 && qty < threshold) {
        stockEl.textContent = dropdown.dataset.lowStockLabel || '';
        stockEl.classList.add('size-stock--low');
      } else {
        stockEl.textContent = '';
        stockEl.classList.remove('size-stock--low');
      }
    });
  }

  function openDropdown(dropdown, trigger) {
    if (isMobile()) {
      dropdown._card = dropdown.closest('product-card');
      dropdown._origParent = dropdown.parentNode;
      dropdown._origNext = dropdown.nextSibling;
      document.body.appendChild(dropdown);
      createBackdrop(function () { closeDropdown(dropdown, trigger); });
    }
    dropdown.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    var card = dropdown._card || dropdown.closest('product-card');
    if (card) updateStockLabels(dropdown, card);
  }

  function closeDropdown(dropdown, trigger) {
    dropdown.hidden = true;
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (dropdown._origParent) {
      dropdown._origParent.insertBefore(dropdown, dropdown._origNext || null);
      dropdown._origParent = null;
      dropdown._origNext = null;
    }
    removeBackdrop();
  }

  function closeAllDropdowns(except) {
    document.querySelectorAll('.product-card__size-dropdown:not([hidden])').forEach(function (d) {
      if (d !== except) {
        var fig = d.closest('.product-card__figure');
        var t = fig ? fig.querySelector('.product-card__size-trigger') : null;
        closeDropdown(d, t);
      }
    });
  }

  // Toggle dropdown on "+" click
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.product-card__size-trigger');
    if (trigger) {
      var dropdownId = trigger.getAttribute('aria-controls');
      var dropdown = document.getElementById(dropdownId);
      if (!dropdown) return;
      var isOpen = !dropdown.hidden;
      closeAllDropdowns(dropdown);
      if (isOpen) {
        closeDropdown(dropdown, trigger);
      } else {
        openDropdown(dropdown, trigger);
      }
      return;
    }

    // Click on a size button inside the dropdown
    var btn = e.target.closest('.product-card__size-btn');
    if (btn && !btn.disabled) {
      var dropdown = btn.closest('.product-card__size-dropdown');
      if (!dropdown) return;
      var card = dropdown._card || btn.closest('product-card');
      if (!card) return;

      var variants = JSON.parse(dropdown.dataset.variants);
      var sizeOptionPos = parseInt(dropdown.dataset.sizeOptionPosition, 10);
      var colorOptionPos = parseInt(dropdown.dataset.colorOptionPosition, 10);
      var colorValue = getColorValueForCard(card, dropdown);
      var variant = findVariantForSize(variants, sizeOptionPos, colorOptionPos, btn.dataset.sizeValue, colorValue);
      if (!variant) return;

      var formEl = card.querySelector('.product-card__size-form form');
      if (!formEl) return;

      formEl.elements['id'].value = variant.id;
      btn.setAttribute('aria-busy', 'true');
      formEl.requestSubmit();
      var sizeTrigger = card.querySelector('.product-card__size-trigger');
      closeDropdown(dropdown, sizeTrigger);
      setTimeout(function () { btn.removeAttribute('aria-busy'); }, 1500);
      return;
    }

    // Desktop: click outside closes dropdowns
    if (!isMobile() &&
        !e.target.closest('.product-card__size-dropdown') &&
        !e.target.closest('.product-card__size-trigger')) {
      closeAllDropdowns(null);
    }
  });

  // When color swatch changes, update tracked variant ID and size button availability
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches('product-card .product-card__info [type="radio"]')) return;
    var card = input.closest('product-card');
    if (!card) return;

    var variantId = input.dataset.variantId;
    if (!variantId) return;
    card.dataset.currentVariantId = variantId;

    var dropdown = card.querySelector('.product-card__size-dropdown');
    if (!dropdown) return;

    var variants = JSON.parse(dropdown.dataset.variants);
    var sizeOptionPos = parseInt(dropdown.dataset.sizeOptionPosition, 10);
    var colorOptionPos = parseInt(dropdown.dataset.colorOptionPosition, 10);
    var matched = variants.find(function (v) { return String(v.id) === variantId; });
    var currentColor = matched ? matched['option' + colorOptionPos] : null;

    dropdown.querySelectorAll('.product-card__size-btn').forEach(function (btn) {
      var sizeVariant = variants.find(function (v) {
        return v['option' + sizeOptionPos] === btn.dataset.sizeValue &&
          (colorOptionPos === 0 || v['option' + colorOptionPos] === currentColor);
      });
      var available = sizeVariant && sizeVariant.available;
      btn.disabled = !available;
      btn.classList.toggle('is-disabled', !available);
    });

    updateStockLabels(dropdown, card);
  });
})();

// Size selection guard: requires the user to pick a size before adding to cart
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('variant-picker').forEach(function (picker) {
    var formId = picker.getAttribute('form-id');
    var form = document.forms[formId];
    if (!form) return;

    var sizeFieldsets = picker.querySelectorAll('fieldset[data-is-size-option]');
    if (sizeFieldsets.length === 0) return;

    function getPlaceholderText() {
      return sizeFieldsets[0].getAttribute('data-size-placeholder') || 'Select a size';
    }

    function hasSizeSelected() {
      return Array.from(sizeFieldsets).every(function (fieldset) {
        return fieldset.querySelector('input[type="radio"]:checked') !== null;
      });
    }

    // Clear the pre-selected variant ID only when no size has been explicitly chosen
    if (form.elements['id'] && !hasSizeSelected()) {
      form.elements['id'].value = '';
    }

    function showSizeError() {
      clearSizeError();
      var buyButtons = document.querySelector('buy-buttons[form="' + formId + '"]');
      if (!buyButtons) return;
      var banner = document.createElement('div');
      banner.className = 'banner banner--error size-required-error';
      banner.setAttribute('role', 'alert');
      banner.setAttribute('aria-live', 'polite');
      banner.textContent = getPlaceholderText();
      buyButtons.prepend(banner);
    }

    function clearSizeError() {
      var existing = form.querySelector('.size-required-error');
      if (existing) existing.remove();
    }

    // Intercept before ProductForm's submit handler using capture phase
    form.addEventListener('submit', function (event) {
      if (!hasSizeSelected()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showSizeError();
      }
    }, { capture: true });

    // Clear error once the user picks a size
    sizeFieldsets.forEach(function (fieldset) {
      fieldset.addEventListener('change', clearSizeError);
    });
  });
});

(function () {
  var THRESHOLD = 110;

  function initDetails(details) {
    var btn = details.querySelector('.facets-filter-show-more');
    var content = details.querySelector('.facets-filter-content');
    if (!btn || !content || btn.dataset.init) return;
    btn.dataset.init = '1';

    btn.addEventListener('click', function () {
      var expanded = content.classList.toggle('is-expanded');
      btn.classList.toggle('open', expanded);
      btn.setAttribute('aria-expanded', String(expanded));
      btn.textContent = expanded ? btn.dataset.labelLess : btn.dataset.labelMore;
    });

    new ResizeObserver(function (entries) {
      var h = entries[0].contentRect.height;
      if (h === 0) return;
      var overflows = content.scrollHeight > THRESHOLD;
      btn.style.display = overflows ? 'block' : 'none';
      content.classList.toggle('has-more', overflows);
    }).observe(content);
  }

  function init(root) {
    (root || document).querySelectorAll('facets-form details').forEach(initDetails);
  }

  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
}());

(function () {
  var tip = null;

  function getOrCreateTip() {
    if (!tip) {
      tip = document.createElement('div');
      tip.className = 'facets-swatch-tooltip';
      tip.setAttribute('aria-hidden', 'true');
      document.body.appendChild(tip);
    }
    return tip;
  }

  document.addEventListener('mouseover', function (e) {
    if (!window.matchMedia('(pointer: fine)').matches) return;
    var swatch = e.target.closest('.facets-filter-content .block-swatch[data-tooltip]');
    if (!swatch) return;
    var el = getOrCreateTip();
    el.textContent = swatch.dataset.tooltip;
    el.style.display = 'block';
    var r = swatch.getBoundingClientRect();
    var tr = el.getBoundingClientRect();
    el.style.left = Math.round(r.left + r.width / 2 - tr.width / 2) + 'px';
    el.style.top  = Math.round(r.bottom + 8) + 'px';
    el.style.borderRadius = 5 + 'px';
  });

  document.addEventListener('mouseout', function (e) {
    var swatch = e.target.closest('.facets-filter-content .block-swatch[data-tooltip]');
    if (swatch && tip) tip.style.display = 'none';
  });
}());
